export function monthRange(month: number, year: number): { from: string; to: string } {
  const from = `${year}-${String(month).padStart(2, '0')}-01`
  const to = month === 12
    ? `${year + 1}-01-01`
    : `${year}-${String(month + 1).padStart(2, '0')}-01`
  return { from, to }
}

export function toDisplayDate(isoDate: string): string {
  const [, m, d] = isoDate.split('-')
  return `${d}/${m}`
}

export function toIsoDate(date: Date): string {
  return date.toISOString().split('T')[0]
}

export function adjustToMonth(isoDate: string, month: number, year: number): string {
  const day = parseInt(isoDate.split('-')[2], 10)
  const lastDay = new Date(year, month, 0).getDate()
  return `${year}-${String(month).padStart(2, '0')}-${String(Math.min(day, lastDay)).padStart(2, '0')}`
}

export function shiftMonth(month: number, year: number, delta: number): { month: number; year: number } {
  const d = new Date(year, month - 1 + delta, 1)
  return { month: d.getMonth() + 1, year: d.getFullYear() }
}

export function isDateInRange(isoDate: string, from: string, to: string): boolean {
  return isoDate >= from && isoDate < to
}

/**
 * Calcula em qual fatura uma compra de cartão cai, retornando a data de
 * vencimento (`due_date`) da fatura correspondente.
 *
 * Regra do ciclo:
 *  - `purchaseDay <= closingDay`  → fatura fecha no mês da compra
 *  - `purchaseDay >  closingDay`  → fatura fecha no mês seguinte
 *  - `dueDay <= closingDay`       → vencimento cai no mês seguinte ao fechamento
 */
export function computeCardDueDate(
  purchaseDate: string,
  closingDay: number,
  dueDay: number,
): string {
  const [year, month, day] = purchaseDate.split('-').map(Number)

  // Qual fechamento se aplica a esta compra?
  let closingMonth = month, closingYear = year
  if (day > closingDay) {
    closingMonth = month === 12 ? 1 : month + 1
    closingYear  = month === 12 ? year + 1 : year
  }

  // O vencimento cai no mesmo mês do fechamento ou no seguinte?
  let dueMonth = closingMonth, dueYear = closingYear
  if (dueDay <= closingDay) {   // ex: fecha 25, vence 5 → próximo mês
    dueMonth = closingMonth === 12 ? 1 : closingMonth + 1
    dueYear  = closingMonth === 12 ? closingYear + 1 : closingYear
  }

  const lastDay = new Date(dueYear, dueMonth, 0).getDate()
  return `${dueYear}-${String(dueMonth).padStart(2, '0')}-${String(Math.min(dueDay, lastDay)).padStart(2, '0')}`
}

/**
 * Filtro `.or()` do PostgREST que agrupa transações pelo mês efetivo:
 *  - transações sem cartão → filtram por `date`
 *  - transações de cartão com `due_date` → filtram por `due_date`
 *  - transações de cartão históricas sem `due_date` → fallback por `date`
 *
 * Centralizado aqui (fonte única) e reutilizado por transactionService e
 * analyticsService. Ver decisão D-B em
 * docs/decisions/2026-06-09-consolidacao-ciclo-fatura-cartao.md
 */
export function effectiveDateFilter(from: string, to: string): string {
  return [
    `and(card_id.is.null,date.gte.${from},date.lt.${to})`,
    `and(card_id.not.is.null,due_date.gte.${from},due_date.lt.${to})`,
    `and(card_id.not.is.null,due_date.is.null,date.gte.${from},date.lt.${to})`,
  ].join(',')
}
